import {styled} from '@mui/material/styles';
import {Box, Grid, TextField, Typography} from "@mui/material";
import {Person} from "@mui/icons-material";

export const MainContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: 0,
  position: 'absolute',
  width: '37.5em',
  left: '42%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: '#FFFFFF',
  borderRadius: '0.5em',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  }
}));

export const Padding = styled(Grid)(() => ({
  padding: '1em'
}));

export const MarginTop = styled(TextField)(() => ({
  marginTop: '1em'
}));

export const MarginBottom = styled(Box)(() => ({
  marginBottom: '1em'
}));

export const VerifyButton = styled(Grid)(() => ({
  backgroundColor: 'rgba(245, 245, 245, 1)',
  padding: '0.5em',
  width: '100%',
}));

export const AccountIcon = styled('img')(() => ({
  width: '1.5em',
  height: '1.5em',
  objectFit: 'contain',
}));

export const PaddingContainer = styled(Box)(() => ({
  padding: '0em 1.71em 0em 1.71em',
}));

export const BankContainer = styled(Box)(() => ({
  borderRadius: '0.5em',
  padding: '1.5em 2.5em 2.5em 2.5em',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}));

export const PersonIcon = styled(Person)(() => ({
  color: 'rgba(0, 0, 0, 0.54)'
}));

export const AppInput = styled(TextField)(() => ({
  marginBottom: '1rem',
  width: '100%',
  '& input': {
    width: '100%',
    fontSize: '.8em'
  },
  '& .MuiInputBase-formControl': {
    background: 'transparent',
    marginTop: '.5em'
  },
  '& .MuiInput-underline:before': {
    borderBottom: '2px solid #6639BF'
  },
  '& label': {
    fontSize: '.8em',
    fontWeight: 400,
    fontFamily: 'Inter',
    lineHeight: '0.8em',
    letterSpacing: '.05em',
    color: '#6639BF',
  }
}));

export const VerifyTitlePrimary = styled(Typography)(() => ({
  fontSize: '1.1em',
  fontWeight: 500,
  fontFamily: 'Inter',
  lineHeight: '1.25em',
  marginTop: '1.5em',
}));

export const VerifyTitleSecondary = styled(Typography)(() => ({
  fontSize: '1.1em',
  fontWeight: 700,
  fontFamily: 'Inter',
  lineHeight: '1.25em',
  marginTop: '1.5em',
  marginBlockEnd: '1.5em',
}));

export const RouteLabel = styled(Typography)(() => ({
  fontSize: '1.1em',
  fontWeight: 500,
  fontFamily: 'Inter',
  lineHeight: '1.25em',
  marginTop: '1.5em',
  marginBlockEnd: '1.5em',
  color: 'rgba(0, 0, 0, 0.6)'
}));

export const BankText = styled(Typography)(() => ({
  fontSize: '1.1em',
  fontWeight: 400,
  fontFamily: 'Inter',
  lineHeight: '1.25em',
  marginTop: '.2em',
  marginLeft: '.5em',
  flex: '1'
}));

export const BankBullet = styled(Box)(() => ({
  width: '0.5em',
  height: '0.5em',
  borderRadius: '50%',
  backgroundColor: '#000000',
}));
